
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Rally } from '../../lib/models/Rally'
import { RallyRound } from '../../lib/models/RallyRound'

@Component({
  components: { }
})
export default class AllRallyRounds extends Vue {
    @Prop({ default: true }) showHeading!: boolean
    @Prop({ default: false }) linkToEditPage!: boolean

    rallyRounds: RallyRound[] = []
    rallies: Rally[] = []

    get sortedRallyRounds () {
      return this.rallyRounds.sort((a: RallyRound, b: RallyRound) => {
        if (!a.dateBegin || !b.dateBegin) {
          return 0
        }
        return new Date(b.dateBegin).getTime() - new Date(a.dateBegin).getTime()
      })
    }

    getRallyForRallyRound (rallyRound: RallyRound) {
      return this.rallies.find(rally => rally.id === rallyRound.rallyId) || new RallyRound()
    }

    mounted () {
      this.loadAllRallyRounds()
    }

    async loadAllRallyRounds () {
      this.rallyRounds = await RallyRound.getAll({})
      this.rallies = await Rally.getAll({})
    }
}
